import { filter } from "ramda";
import { User } from "../types";

export default (friends: User[]) => filter(friend => friend.userRelationship === "pending", friends);
